import * as React from 'react'

// Sample offerings
import { Fieldset, InputText, Legend } from '@paytrace/pt-skel/Component'
import { ResponseFeedback } from './Component/ResponseFeedback'

function sample (x: any, ps: any): React.ReactNode {
  const name = x.toString().split('\n')[0]
  let i = 0
  const els = ps.map((p: any, iter: number) => {
    const el = React.createElement(x as any, {
      ...p,
      key: name + i++,
    })

    return (
      <tr key={iter}>
        <td>
          <div key={'wrapper-' + name + i}>
            <pre className='props'>Props: {JSON.stringify(p, null, 2)}</pre>
            <div className='render'>{el}</div>
          </div>
        </td>
      </tr>
    )
  })

  return (
    <div className='sample'>
      <h3>{name}</h3>
      {els}
    </div>
  )
}

interface P {
  widget: string
}

const approvalData = {
  transaction_id: 1067780,
  response_code: 101,
  transaction_identifier: '0124MCG123456789',
  response_message: 'Your transaction was successfully approved.',
  approval_code: '011764',
  approval_message: 'APPROVAL 011764',
  amount: 1.20,
  emails: ['rhondaqa@gmail.com', 'mcarter@paytrace.com'],
}

export function Dev (props: P) {
  return (
    <div>
      <table className='dev-samples'>
        {sample(ResponseFeedback, [approvalData])}
        {sample(Fieldset, [{}])}
        {sample(InputText, [{ label: 'Input text label here' }])}
        {sample(Legend, [{ title: 'Some Legend Title' }])}
      </table>
      <br className='clear' />
    </div>
  )
}

export default Dev
